import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpEventType
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
// import { retry, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '../Service/loader.service';
import 'rxjs/add/operator/finally';

@Injectable()
export class HttpclientInterceptor implements HttpInterceptor {
  constructor(
    private cookieService: CookieService,
    public loaderService: LoaderService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      this.loaderService.show();
      return next.handle(req).pipe()
      .finally(() => this.loaderService.hide());
  }

}
